import React, { useEffect, useState } from "react";
import { authFB, db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import CardMyRaffle from "./CardMyRaffle";
import { useNavigate } from "react-router-dom";
import { FaTicketAlt } from "react-icons/fa";
import SidebarDash from "./SidebarDash";
import { FaPlusCircle } from "react-icons/fa";

function ListMyRaffles() {
  const [raffles, setRaffles] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const userId = authFB.currentUser ? authFB.currentUser.uid : null; 

  useEffect(() => {
    const fetchRaffles = async () => {
      if (!userId) return; // Si no hay usuario, no haces la consulta

      const rafflesSnapshot = await getDocs(collection(db, "raffles"));
      const rafflesList = rafflesSnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((raffle) => raffle.userId === userId); // Filtra por userId

      setRaffles(rafflesList);
    };

    fetchRaffles();
  }, [userId]); 

  const handleRaffleClick = (raffleId) => {
    navigate(`/raffles/${raffleId}`);
  };

  return (
    <div className="flex flex-col md:flex-row h-screen" style={{
      background:"#eaeaec"
    }}>
    
    <SidebarDash />

      <main className="p-7">
        <h1 className="text-2xl font-bold mb-4 text-black flex items-center"><FaTicketAlt className="mr-2" /> Mis rifas</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <a href="/create" style={{
            width:"100%",
            height:"15px",
            padding:"30px",
            border:"1px dashed gray",
            borderRadius:"16px", display:"flex", alignItems:"center", justifyContent:"center", gap:"4px"
          }} className="hover:bg-blue-600 hover:text-white cursor-pointer">
            <FaPlusCircle /> Crear nueva rifa
          </a>

          {raffles.map((props, key) => (
            <CardMyRaffle key={key} {...props} onClick={() => handleRaffleClick(props.id)} />
          ))}
        </div>
      </main>
    </div>
  );
}

export default ListMyRaffles;
